// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatListPinsBody = {
  chatId: string;
};

export type typeChatListPinsOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      messageId: string;
      body?: string | null;
      senderDisplayName: string;
      pinnedAtIso: string;
      pinnedByUserId: string;
      pinnedByDisplayName: string;
      kind?:
        | "text"
        | "image"
        | "gif"
        | "poll"
        | "gameCard"
        | "systemAnnouncement"
        | "pdf"
        | null;
      pollQuestion?: string | null;
      gameCardLabel?: string | null;
    }[];
    total: number;
    nextCursor: string | null;
  };
};

export type typeChatListPinsOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListPinsOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatListPinsOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatListPinsBody = {
  type: "object",
  properties: { chatId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["chatId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatListPins(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatListPinsBody);
  }

  return async function postChatListPins(
    payload: typeChatListPinsBody,
  ): Promise<typeChatListPinsOutput200 | typeChatListPinsOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatListPins" failed before calling the network. #e99bd019c3c4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e99bd019c3c4" },
        },
        data: null,
      } as typeChatListPinsOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/list-pins`,
      httpMethod: "POST",
      options,
    })) as typeChatListPinsOutput200 | typeChatListPinsOutput400;
  };
}
